<div class="form-group">
  <div class="row fields-group">
    <div class="col">
      <label class="input-label">{{ 'File Upload Event' | translate }}</label>
      <select name="fileUploadEventName" [(ngModel)]="fileUploadEventName" (change)="fileUploadEventNameChanged()" class="form-control">
        <option value="" disabled>{{ 'Choose here' | translate }}</option>
        <option *ngFor="let event of fileUploadEvents" [value]="event.key">{{ event.name }}</option>
      </select>
    </div>
  </div>
</div>
